import React from 'react';
import { EyeOff } from 'lucide-react';

export const scoreColor = (s) => (s >= 85 ? '#059669' : s >= 70 ? '#2563EB' : s >= 50 ? '#D97706' : '#DC2626');

export const ScoreRing = ({ score, size = 132, label = 'Overall' }) => {
  const r = (size - 14) / 2;
  const c = 2 * Math.PI * r;
  return (
    <div className="relative shrink-0" style={{ width: size, height: size }} data-testid="report-overall-score-badge">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#E2E8F0" strokeWidth="10" />
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={scoreColor(score)} strokeWidth="10" strokeLinecap="round"
          strokeDasharray={c} strokeDashoffset={c - (score / 100) * c} style={{ transition: 'stroke-dashoffset 1.2s ease' }} />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="text-4xl font-extrabold text-slate-900 tracking-tight" style={{ fontFamily: 'Manrope, sans-serif' }}>{score}%</span>
        <span className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold">{label}</span>
      </div>
    </div>
  );
};

const LEVEL_TONE = {
  Expert: 'bg-emerald-600 text-white', Advanced: 'bg-blue-600 text-white',
  Intermediate: 'bg-amber-500 text-white', Beginner: 'bg-red-600 text-white',
};

export const LevelBadge = ({ level }) => (
  <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-bold tracking-wide ${LEVEL_TONE[level] || 'bg-slate-600 text-white'}`}
    data-testid="report-expertise-level">{level}</span>
);

export const Metric = ({ label, value, sub, testid }) => (
  <div className="rounded-xl border border-slate-200 bg-white px-4 py-3" data-testid={testid}>
    <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-500">{label}</p>
    <p className="mt-1 text-xl font-extrabold text-slate-900" style={{ fontFamily: 'Manrope, sans-serif' }}>{value}</p>
    {sub && <p className="text-[11px] text-slate-500 mt-0.5">{sub}</p>}
  </div>
);

export const HiddenBadge = ({ testid }) => (
  <span className="inline-flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wider text-amber-800 bg-amber-50 border border-amber-200 px-2 py-0.5 rounded-full"
    title="Switched off in Config — not shown on the shared link or PDF" data-testid={testid}>
    <EyeOff className="h-3 w-3" /> Hidden from shared report
  </span>
);
